// extracted by mini-css-extract-plugin
export var aiStarIcon = "_kl-2";
export var container = "_kl-4";
export var dismissButton = "_kl-3";
export var hasPaddingBottom = "_kl-6";
export var last = "_kl-e";
export var scrollbarThumb = "_kl-c";
export var scrollbarTrack = "_kl-b";
export var selected = "_kl-9";
export var spin = "_kl-1";
export var spinning = "_kl-0";
export var suggestionItem = "_kl-d";
export var suggestionsPanel = "_kl-5";
export var tonePill = "_kl-8";
export var tonesContainer = "_kl-7";
export var unselected = "_kl-a";